export default __webpack_public_path__ + "static/media/jewelry.6a246509.png";